// these are the possible validation results from our backend
// app/controllers/sq/concerns/address_validation_response_converter_concern.rb
export enum VALIDATION_RESULTS {
  VALIDATED = 'validated',
  VALIDATED_BY_PRIMARY = 'validated_by_primary',
  FAILED = 'failed',
  VALIDATION_SERVICE_ERROR = 'validation_service_error',
  UNKNOWN_STATUS = 'unknown_status',
}

// https://prototype.sqprod.co/#/docs/squareup.address.service.AddressResult.Status
// potentially may need to support more of these statuses in the future
export enum ADDRESS_RESULT_STATUS {
  SUCCESS = 'SUCCESS',
  FAILED_VERIFICATION = 'FAILED_VERIFICATION',
}

// https://prototype.sqprod.co/#/docs/squareup.common.address.Verification.VerificationStatus
export enum VERIFICATION_STATUS {
  VERIFIED = 'VERIFIED',
  PARTIALLY_VERIFIED = 'PARTIALLY_VERIFIED',
  VERIFY_FAILED = 'VERIFY_FAILED',
}

export interface ValidationRequestAddress {
  first_name?: string;
  last_name?: string;
  company?: string;
  phone?: string;
  address_line_1: string;
  address_line_2?: string;
  locality: string;
  administrative_district_level_1: string;
  postal_code: string;
  country_code: string;
}

export interface ValidationResponseAddress {
  service_name: string | null;
  token: string | null;
  first_name: string | null;
  last_name: string | null;
  name: string | null;
  company: string | null;
  phone: string | null;
  address_line_1: string;
  address_line_2: string;
  locality: string;
  administrative_district_level_1: string;
  postal_code: string;
  country_code: string;
}

export interface AddressValidationResult {
  result: VALIDATION_RESULTS;
  original_address: ValidationResponseAddress;
  corrected_address: ValidationResponseAddress;
  changed_fields: string[];
  address_service_statuses: {
    status: ADDRESS_RESULT_STATUS;
    verification_status: VERIFICATION_STATUS;
  };
}

export interface AddressValidationRequest {
  address_validation_request: {
    address: ValidationRequestAddress;
    save: boolean;
  };
}

export interface AddressValidationResponse {
  address_validation_result: AddressValidationResult;
}
